import React from 'react';

import { Samtykkeoppdrag } from '../../generated-types';
import { useTranslation } from '../../translations';
import { formatDate } from '../../utils/dateUtils';
import { TaskExpandCard } from '../TaskExpandCard';
import { ConsentAssignmentLabels } from './ConsentAssignmentLabels';
import { ConsentAssignmentTasks } from './ConsentAssignmentTasks';

interface ConsentAssignmentProps {
    consentAssignmentTask: Samtykkeoppdrag;
}
const ConsentAssignment = ({ consentAssignmentTask }: ConsentAssignmentProps) => {
    const { consentAssignment } = useTranslation();
    const deadlineHasPassed = consentAssignmentTask.status === 'EXPIRED';
    const formattedDeadline = formatDate(new Date(consentAssignmentTask.frist));
    const deadlineIsToday = formattedDeadline === formatDate(new Date());
    const taskIsDone = consentAssignmentTask.status === 'ACCEPTED';
    return (
        <TaskExpandCard
            title={consentAssignment.title}
            description={consentAssignmentTask.banknavn ?? ''}
            deadlineHasPassed={deadlineHasPassed}
            deadlineIsToday={deadlineIsToday}
            taskIsDone={taskIsDone}
            tasks={
                <ConsentAssignmentTasks
                    interestedParty={consentAssignmentTask.interessenttype ?? ''}
                    bankName={consentAssignmentTask.banknavn ?? ''}
                    namePrincipalBorrower={consentAssignmentTask.navnHovedlaantaker ?? ''}
                    deadlineHasPassed={deadlineHasPassed}
                    taskUrl={consentAssignmentTask.altinnKundeSamtykkeUrl}
                    taskIsDone={taskIsDone}
                />
            }
            labels={
                <ConsentAssignmentLabels
                    status={consentAssignmentTask.status}
                    deadline={formattedDeadline}
                    deadlineIsToday={deadlineIsToday}
                />
            }
        />
    );
};

export default ConsentAssignment;
